import { render, staticRenderFns } from "./critical_asset.vue?vue&type=template&id=2c8ec6ce"
import script from "./critical_asset.vue?vue&type=script&lang=js"
export * from "./critical_asset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports